// extracted by mini-css-extract-plugin
export default {"paginationComponent":"Pagination_paginationComponent__4z6G1"};